import { useClient, useSession } from '@playbooks/contexts';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

const MktPrefooter = () => {
	const session = useSession();
	const { platformHref } = useClient();

	// Render
	return (
		<section className='relative w-full overflow-hidden border-y'>
			<div className='z-10 h-full py-24'>
				<div className='mx-auto w-full max-w-lg px-4 lg:px-20'>
					<div className='w-full space-y-4 text-center'>
						<h2 className='type-display'>
							<span>Build Fast,</span>
							<span className='ml-2 text-foreground-body'>Build Smart</span>.
						</h2>
						<p className='type-body'>Join us and let's build a new developer economy together.</p>
					</div>
					<div className='mx-auto flex-middle gap-2 pt-8'>
						{session.isAuthenticated() ? (
							<Link variant='outline' href={platformHref('/home')}>
								View Dashboard
								<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
							</Link>
						) : (
							<Link variant='outline' href={platformHref('/auth')}>
								Sign in
								<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
							</Link>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};
export { MktPrefooter };
